module.exports = __webpack_public_path__ + "static/img/s4.d2e7e48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/s4.png
// module id = BvzG
// module chunks = 0